import { Power } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import brandLogo from "../../assets/images/logo4.png";
const config = require("../../assets/config.json");

export default function Header() {
  const { user } = useAuth();
  const parsedUserInfo = typeof user === "string" ? JSON.parse(user) : user;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 text-white flex flex-col sm:flex-row items-center justify-between px-4 py-5 "
      style={{ backgroundColor: "#347BF5" }}
    >
      {/* Left Section - Logo and Nav */}
      <div className="flex items-center space-x-6">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <div className=" p-1">
            <img
              src={brandLogo}
              alt="brand_logo"
              height={"45px"}
              width={"45px"}
            />
          </div>
          <div>
            <h1 className="text-2xl font-bold">XpertDesk</h1>
            <p className="text-xs italic">Connect. Request. Resolve</p>
          </div>
        </div>
      </div>

      {/* Right Section - Portal Link + User Info */}
      <div className="flex items-center space-x-4">
        <button
          className="flex items-center space-x-1"
          onClick={() => {
            window.location.href = config?.REACT_APP_LOGINGATEWAY_DASHBOARD;
          }}
        >
          <i className="fa fa-reply fa-lg icon-black" aria-hidden="true"></i>
          <span className="align-middle ms-50"> &nbsp;IX Portal</span>
        </button>

        <div className="text-right">
          <p className="font-semibold">{parsedUserInfo?.actort}</p>
          <p className="text-sm">{parsedUserInfo?.RoleName}</p>
        </div>

        <button
          className="p-2 rounded-full border-2 border-white hover:border-3 hover:border-white transition"
          onClick={() => {
            window.location.href = config?.REACT_APP_LOGINGATEWAY + "/logout";
          }}
        >
          <Power />
        </button>
      </div>
    </div>
  );
}
